class FlagshipProductAdv {
  constructor(sectionElement) {
    this.section = sectionElement;
    this.sectionId = this.section.dataset.sectionId;
    
    // Parse Product Data
    this.productData = JSON.parse(this.section.querySelector('[data-product-json]').textContent);
    this.productOptions = JSON.parse(this.section.querySelector('[data-options-json]').textContent);
    
    // Parse Inventory Data
    this.inventoryData = JSON.parse(this.section.querySelector('[data-inventory-json]').textContent);

    // Initial State
    this.currentVariantId = this.productData[0].id;
    this.selectedOptions = {};
    this.initSelectedOptions();
    
    // Elements
    this.variantButtons = this.section.querySelectorAll('.flagship-adv__var-opt');
    this.qtyButtons = this.section.querySelectorAll('.flagship-adv__qty-btn');
    
    // Bind Methods
    this.handleVariantChange = this.handleVariantChange.bind(this);
    this.handleQtyChange = this.handleQtyChange.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    
    // Initialization
    this.addEventListeners();
    this.initSmartSwipe(); // <--- REPLACED initMobileGallery
    this.initStickyBar();
    this.initLightbox();
    // Removed subscribeToCartEvents();

    // Apply inventory rules for initial variant
    const initialVariant = this.productData.find(v => v.id === this.currentVariantId);
    if (initialVariant) {
      this.updateQtyRules(initialVariant);
      this.updateInventoryStatus(initialVariant); 
    }
  }

  initSelectedOptions() {
    this.section.querySelectorAll('.flagship-adv__var-group').forEach((group, index) => {
      const selectedBtn = group.querySelector('.selected');
      if (selectedBtn) {
        this.selectedOptions[this.productOptions[index]] = selectedBtn.dataset.value;
      }
    });
  }

  addEventListeners() {
    // Variants
    this.variantButtons.forEach(btn => {
      btn.addEventListener('click', (e) => this.handleVariantChange(e.target));
    });

    // Quantity
    this.qtyButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const change = parseInt(e.target.dataset.qtyChange);
        this.handleQtyChange(e.target, change);
      });
    });

    // Sticky Bar Trigger
    const stickyTrigger = this.section.querySelector('[data-trigger-atc]');
    if (stickyTrigger) {
      stickyTrigger.addEventListener('click', () => {
        const mobFormBtn = this.section.querySelector('.flagship-adv__info-mobile button[type="submit"]');
        if (mobFormBtn) mobFormBtn.click();
      });
    }
  }

  handleVariantChange(element) {
    const optionName = element.dataset.optionName;
    const value = element.dataset.value;
    
    // UI Update
    const container = element.closest('.flagship-adv__var-group');
    container.querySelectorAll('.flagship-adv__var-opt').forEach(el => el.classList.remove('selected'));
    element.classList.add('selected');

    // State Update
    this.selectedOptions[optionName] = value;
    
    // Match Variant
    const matchedVariant = this.productData.find(variant => {
      return variant.options.every((val, index) => {
        const key = this.productOptions[index];
        return this.selectedOptions[key] === val;
      });
    });

    if (matchedVariant) {
      this.currentVariantId = matchedVariant.id;
      this.updateForms(matchedVariant);
      this.updatePrice(matchedVariant);
      this.updateSku(matchedVariant);
      this.updateUrl(matchedVariant);
      this.updateQtyRules(matchedVariant);
      this.updateInventoryStatus(matchedVariant); 
    }
  }

  updateForms(variant) {
    // Update hidden inputs in all forms (desktop, mobile, sticky) within this section
    const inputs = this.section.querySelectorAll('.flagship-adv__variant-id');
    inputs.forEach(input => {
      input.value = variant.id;
      // Dispatch event so other listeners know it changed
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePrice(variant) {
    const prices = this.section.querySelectorAll('.flagship-adv__price-text');
    prices.forEach(price => price.innerText = this.formatMoney(variant.price));
  }

  updateSku(variant) {
    const skus = this.section.querySelectorAll('.flagship-adv__sku');
    skus.forEach(sku => sku.innerText = variant.sku || '');
  }

  updateUrl(variant) {
    const newUrl = new URL(window.location);
    newUrl.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', newUrl);
  }

  // Update Inventory Status Logic
  updateInventoryStatus(variant) {
    const elements = this.section.querySelectorAll('.flagship-adv__inventory');
    const inventoryInfo = this.inventoryData[variant.id];
    
    elements.forEach(el => {
      const textSpan = el.querySelector('.flagship-adv__inventory-text');
      
      // Check logic: Available AND Quantity > 0 AND Quantity < 4
      if (variant.available && inventoryInfo && inventoryInfo.quantity > 0 && inventoryInfo.quantity < 4) {
        el.classList.remove('hidden');
        if (textSpan) textSpan.innerText = `Only ${inventoryInfo.quantity} Left`;
      } else {
        el.classList.add('hidden');
      }
    });
  }

  updateQtyRules(variant) {
    const qtyInputs = this.section.querySelectorAll('.flagship-adv__qty-input');
    const inventoryInfo = this.inventoryData[variant.id];
    
    qtyInputs.forEach(input => {
      if (inventoryInfo && inventoryInfo.management === 'shopify' && inventoryInfo.policy === 'deny') {
        const max = inventoryInfo.quantity;
        input.setAttribute('max', max);
        // If current val > max, clamp it immediately
        if (parseInt(input.value) > max) {
          input.value = max > 0 ? max : 1; 
        }
      } else {
        input.removeAttribute('max');
      }
    });
  }

  handleQtyChange(btn, change) {
    const container = btn.closest('.flagship-adv__qty');
    const input = container.querySelector('input');
    let val = parseInt(input.value) + change;
    
    // Check Max
    const max = input.getAttribute('max');
    if (max && val > parseInt(max)) {
      val = parseInt(max);
    }
    
    // Check Min
    if (val < 1) val = 1;

    input.value = val;
    // Dispatch event so product-form.js or others pick up the change
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  formatMoney(cents) {
    return "$" + (cents / 100).toFixed(2); 
  }

  // --- SmartSwipe Engine (Mobile Gallery) ---
  initSmartSwipe() {
    const track = this.section.querySelector('[data-gallery-mobile]');
    const slides = this.section.querySelectorAll('.flagship-adv__mob-item');
    const counter = this.section.querySelector('[data-mob-counter]');
    const navBtns = this.section.querySelectorAll('[data-mob-scroll]');

    if (!track || slides.length === 0) return;

    // IMPORTANT: Make slides sit side-by-side
    track.style.overflow = 'visible'; 
    track.style.display = 'flex';
    track.style.width = '100%';

    // State
    let currentIndex = 0;
    let startX = 0;
    let startY = 0;
    let isDragging = false;
    let isHorizontalSwipe = false;
    let isDirectionLocked = false;
    let isClickBlocked = false; 

    // Helper: Move Slider
    const updateSlide = (index, animate = true) => {
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;
        currentIndex = index;
        
        const offset = -currentIndex * 100;
        track.style.transition = animate ? 'transform 0.3s cubic-bezier(0.25, 1, 0.5, 1)' : 'none';
        track.style.transform = `translateX(${offset}%)`;
        
        // Update Counter
        if (counter) counter.innerText = (currentIndex + 1) + " / " + slides.length;
    };

    // --- Touch Events (Mobile/Tablet) ---
    track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isDragging = true;
        isDirectionLocked = false;
        isHorizontalSwipe = false;
        track.style.transition = 'none'; 
    }, { passive: true });

    track.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        
        const currentX = e.touches[0].clientX;
        const currentY = e.touches[0].clientY;
        const diffX = currentX - startX;
        const diffY = currentY - startY;

        // Direction Lock Logic
        if (!isDirectionLocked) {
            if (Math.abs(diffX) > 10 || Math.abs(diffY) > 10) {
                isDirectionLocked = true;
                if (Math.abs(diffX) > Math.abs(diffY)) {
                    isHorizontalSwipe = true;
                }
            }
        }

        if (isHorizontalSwipe) {
            if (e.cancelable) e.preventDefault(); // Stop Page Scroll
            e.stopPropagation();
            
            // 1:1 Movement logic
            const slideWidth = track.offsetWidth;
            const currentOffset = -currentIndex * slideWidth;
            const newOffset = currentOffset + diffX;
            track.style.transform = `translateX(${newOffset}px)`;
        }
    }, { passive: false });

    track.addEventListener('touchend', (e) => {
        if (!isDragging) return;
        isDragging = false;

        if (isHorizontalSwipe) {
            const endX = e.changedTouches[0].clientX;
            const diffX = endX - startX;
            const threshold = 50;

            if (diffX > threshold) {
                updateSlide(currentIndex - 1);
            } else if (diffX < -threshold) {
                updateSlide(currentIndex + 1);
            } else {
                updateSlide(currentIndex);
            }
            e.stopPropagation();
        } else {
            // Revert any slight drags
            updateSlide(currentIndex);
        }
    }, { passive: true });

    // --- Mouse Events (Desktop/Hybrid Drag) ---
    track.addEventListener('mousedown', (e) => {
        e.preventDefault(); 
        startX = e.clientX;
        isDragging = true;
        isDirectionLocked = true; 
        isHorizontalSwipe = true;
        isClickBlocked = false; 
        track.style.transition = 'none';
    });

    track.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        
        const diffX = e.clientX - startX;
        if (Math.abs(diffX) > 5) isClickBlocked = true;

        const slideWidth = track.offsetWidth;
        const currentOffset = -currentIndex * slideWidth;
        track.style.transform = `translateX(${currentOffset + diffX}px)`;
    });

    const endDrag = (e) => {
        if (!isDragging) return;
        isDragging = false;
        const diffX = e.clientX - startX;
        const threshold = 50;
        
        if (diffX > threshold) updateSlide(currentIndex - 1);
        else if (diffX < -threshold) updateSlide(currentIndex + 1);
        else updateSlide(currentIndex);
    };

    track.addEventListener('mouseup', endDrag);
    track.addEventListener('mouseleave', endDrag);

    // --- Click Interceptor ---
    track.addEventListener('click', (e) => {
        if (isClickBlocked) {
            e.preventDefault();
            e.stopPropagation();
        }
    }, { capture: true });

    // --- Arrow Click Events (Replaces old logic) ---
    navBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const dir = parseInt(e.target.dataset.mobScroll);
            updateSlide(currentIndex + dir);
        });
    });
  }

  // --- STICKY BAR LOGIC ---
  initStickyBar() {
    const bar = this.section.querySelector('[data-sticky-bar]');
    if (!bar) return;

    document.addEventListener('scroll', () => {
      if (window.innerWidth > 767) return;
      const mobBtn = this.section.querySelector('.flagship-adv__info-mobile button[type="submit"]');
      if (!mobBtn) return;
      
      const rect = mobBtn.getBoundingClientRect();
      if (rect.bottom < 0) {
        bar.classList.add('visible');
      } else {
        bar.classList.remove('visible');
      }
    });
  }

  // --- LIGHTBOX LOGIC ---
  initLightbox() {
    this.lightbox = this.section.querySelector('[data-lightbox]');
    this.track = this.section.querySelector('[data-lightbox-track]');
    this.zoomIndex = 0;
    
    // Open Triggers
    const triggers = this.section.querySelectorAll('[data-open-zoom]');
    triggers.forEach(t => {
      t.addEventListener('click', () => {
        this.zoomIndex = parseInt(t.dataset.openZoom);
        this.openZoom();
      });
    });

    // Close
    const closeBtn = this.section.querySelector('[data-close-zoom]');
    if (closeBtn) closeBtn.addEventListener('click', () => this.closeZoom());
    
    if (this.lightbox) {
      this.lightbox.addEventListener('click', (e) => {
        if (e.target === this.lightbox) this.closeZoom();
      });
    }

    // Nav
    const navBtns = this.section.querySelectorAll('[data-zoom-nav]');
    navBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const dir = parseInt(e.target.dataset.zoomNav);
        this.changeSlide(dir);
      });
    });
  }

  openZoom() {
    this.updateTrack();
    this.lightbox.classList.add('active');
    document.addEventListener('keydown', this.handleKeydown);
  }

  closeZoom() {
    this.lightbox.classList.remove('active');
    document.removeEventListener('keydown', this.handleKeydown);
  }

  changeSlide(dir) {
    this.zoomIndex += dir;
    const total = this.track.children.length;
    if (this.zoomIndex < 0) this.zoomIndex = total - 1;
    if (this.zoomIndex >= total) this.zoomIndex = 0;
    this.updateTrack();
  }

  updateTrack() {
    this.track.style.transform = `translateX(-${this.zoomIndex * 100}%)`;
  }

  handleKeydown(e) {
    if (e.key === 'Escape') this.closeZoom();
    if (e.key === 'ArrowLeft') this.changeSlide(-1);
    if (e.key === 'ArrowRight') this.changeSlide(1);
  }
}

// Initialize on Load and Theme Editor changes
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.flagship-adv__wrapper').forEach(el => new FlagshipProductAdv(el));
});

document.addEventListener('shopify:section:load', (e) => {
  const el = e.target.querySelector('.flagship-adv__wrapper');
  if (el) new FlagshipProductAdv(el);
});